<script>
  import { Field, FieldActions, FieldHeader, FieldLabel, FieldValue } from '@client/components/fields/standalone/base';
  import { Switch } from '@client/components/switch';

  export let id = null;
  export let label = null;
  export let valueOn = null;
  export let valueOff = null;

  export let badge = undefined;
  export let tooltip = undefined;
  export let tooltipIcon = undefined;

  export let checked = false;

  export let ref = null;

  export let disabled = null;
  export let editing = false;
  export let readonly = false;
  export let inverted = false;

  export let showActions = true;

  export let onChange = () => {};
  export let onUpdate = () => {};

  let value = inverted ? !checked : checked;
  let disableSubmit = true;

  const onEdit = () => {
    editing = true;
  };

  const onCancel = () => {
    editing = false;
    value = inverted ? !checked : checked;
  };

  const onChangeHandler = () => {
    onChange(id, label, inverted ? !value : value);
  };

  const onSave = () => {
    checked = inverted ? !value : value;
    editing = false;

    if (onUpdate) {
      onUpdate(id, label, checked);
    }
  };

  $: disableSubmit = (inverted ? !checked : checked) === value;
</script>

<Field bind:editing>
  <FieldHeader>
    <FieldLabel {label} {tooltipIcon} {tooltip} />
    <FieldActions bind:readonly bind:editing bind:disableSubmit {onSave} {onEdit} {onCancel} {badge} {showActions} />
  </FieldHeader>
  <FieldValue {showActions}>
    {#if editing}
      <Switch bind:ref bind:checked={value} on:change={onChangeHandler} {disabled} />
    {:else if value === true}
      {@html valueOn ?? value}
    {:else}
      {@html valueOff ?? value}
    {/if}

    {#if !editing}
      <slot name="inline" />
    {/if}
  </FieldValue>
  {#if !editing}
    <slot />
  {/if}
</Field>

<style lang="scss" src="./switch.scss"></style>
